import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatisticsMapsGraphService {
  private isLoading$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  public getIsLoading = (): Observable<boolean> => {
    return this.isLoading$.asObservable();
  };

  public setIsLoading = (isLoading: boolean) => {
    this.isLoading$.next(isLoading);
  };
}
